export default __webpack_public_path__ + "static/media/CZ-RTC6BLW 3.d1c6990a.jpg";